import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const isGradedState = atom({
  key: 'isGradedState',
  default: false,
});
//다시풀기 버튼 관련
// export const solveAgainState = atom({ key: 'solveAgainState', default: false });
// export const solveAgainState = atom({
//   key: 'solveAgainState',
//   default: false,
//   effects_UNSTABLE: [persistAtom]
// });

//도움말 관련
export const isPageOpenedState = atom({
  key: 'isPageOpenedState',
  default: false,
});

export const quizDetailPageHeightState = atom({
  key: 'quizDetailPageHeightState',
  default: 0,
});

export const quizDetailPageWidthState = atom({
  key: 'quizDetailPageWidthState',
  default: 0,
});

//케이스 문제 페이지에서 도움말의 현재 상태값
export const currentProcessState = atom({
  key: 'currentProcessSate',
  default: { step: 0, name: '' },
});

//채점하는 도중에 로딩 표시 관련 상태값
export const gradingLoadingState = atom({
  key: 'gradingLoadingState',
  default: false,
});

//문제 해설 탭 전환
export const descriptionKeyState = atom({
  key: 'descriptionKeyState',
  default: 'question',
});

export const isResettingDoneState = atom({
  key: 'isResettingDoneState',
  default: false,
});

export const quizListFilterState = atom({
  key: 'quizListFilterState',
  default: {
    subject: [],
    quiz_types: [],
    is_full_drill: [],
    tagNames: [] as any[],
    count: 0,
    link: '',
  },
  effects_UNSTABLE: [persistAtom],
});
